const GOSATS_SESSION_TYPE = 'GOSATS_SESSION';

// Persist the access token so the rest of the app (apiFetch, hooks) can read it
// from sessionStorage as the single source of truth.
function persistAccessToken(accessToken) {
    if (accessToken) {
        sessionStorage.setItem('AccessToken', accessToken);
        return accessToken;
    }
    return null;
}

// Read the session that the native app injects synchronously on the window.
// Returns the access token if present, otherwise falls back to sessionStorage.
export function getSessionToken() {
    try {
        const session = window.__GOSATS_SESSION__;
        if (session && session.type === GOSATS_SESSION_TYPE && session.accessToken) {
            return persistAccessToken(session.accessToken);
        }
    } catch (e) {
        console.log('NATIVE EVENT: GET SESSION ERROR', e);
    }
    return sessionStorage.getItem('AccessToken');
}

// Listen for the session message the native app posts into the webview.
// Handles both `window` (iOS) and `document` (Android) message targets.
// Returns a cleanup function that removes the listeners.
export function listenForSession(onToken) {
    const handler = (event) => {
        try {
            const payload = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
            if (payload && payload.type === GOSATS_SESSION_TYPE && payload.accessToken) {
                persistAccessToken(payload.accessToken);
                if (typeof onToken === 'function') onToken(payload.accessToken);
            }
        } catch (e) {
            // Ignore messages that aren't the GoSats session payload.
        }
    };

    window.addEventListener('message', handler);
    document.addEventListener('message', handler);

    return () => {
        window.removeEventListener('message', handler);
        document.removeEventListener('message', handler);
    };
}

export function goBack() {
    console.log('NATIVE EVENT: GO BACK');
    const data = {
        event: 'back'
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function shopNow() {
    console.log('NATIVE EVENT: SHOP NOW');
    const data = {
        event: 'Shop'
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}
export function loadCard() {
    console.log('NATIVE EVENT: Laod Card');
    const data = {
        active: true,
        event: 'navigate',
        location: 'RechargeCard'
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}
export function activateCard() {
    console.log('NATIVE EVENT: Activate Card');
    const data = {
        active: true,
        event: 'navigate',
        location: 'screenCardOnBoardingIntroAnim'
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}
export function offersBrands() {
    console.log('NATIVE EVENT: OFFERS BRANDS');
    const data = {
        active: true,
        event: 'navigate',
        location: 'Dashboard',
        data: {
            screen: 'Brands',
            params: { scrollToSection: '' }
            // params: { scrollToSection: 'Bitcoin Rewards Bonanza' }
        }
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function goToBrandCategory(category) {
    console.log('NATIVE EVENT: BRAND CATEGORY', category);
    const data = {
        active: true,
        event: 'navigate',
        location: 'Dashboard',
        data: {
            screen: 'Brands',
            params: { scrollToSection: category }
        }
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function purchaseCard(code) {
    console.log('NATIVE EVENT: BUY CARD');
    if (code && window?.navigator?.clipboard) {
        window.navigator.clipboard.writeText(code);
    }
    const data = {
        active: true,
        /* data: {
            code: code
        }, */
        event: 'navigate',
        location: 'screenCardCompare'
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function upgradeCard(code) {
    console.log('NATIVE EVENT: BUY CARD');
    if (code && window?.navigator?.clipboard) {
        window.navigator.clipboard.writeText(code);
    }
    const data = {
        active: true,
        /* data: {
            code: code
        }, */
        event: 'navigate',
        location: 'screenUpgradeCardInfo'
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function shareWithFriends(message) {
    const msg = `${message} `;
    console.log('NATIVE EVENT: SHARE WITH FRIENDS', message);
    const data = {
        event: 'share',
        message: msg
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function shareReferral(code, link) {
    console.log('NATIVE EVENT: SHARE REFERRAL', code, link);
    const msg = `Hey! Join me in the Bitcoin Premier League and win exciting rewards in Bitcoin & Gold every time you shop. ${link}`
    // const msg = `Heyy! 😃 Use my personal GoSats Valentines Week invite to earn Flat 10% rewards in Gold or Bitcoin on brands like Swiggy, Zomato, Myntra, Nykaa and many more with the GoSats Elite card. Offer ends on 14th February, end of day. Thank me later!\nGet now: https://gosats.onelink.me/O1LB/pj1bifwh`
    console.log('NATIVE EVENT: SHARE WITH FRIENDS', msg);
    const data = {
        event: 'share',
        message: msg
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function goHistory() {
    console.log('NATIVE EVENT: HISTORY');
    const data = {
        event: "TabNavigate",
        location: "History"
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function goMerchant(id) {
    console.log('NATIVE EVENT: MERCHANT PAGE');
    const data = {
        event: "navigate",
        location: "BrandDetail",
        data: {
            id: id
        }
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function goHome() {
    console.log('NATIVE EVENT: HOME');
    const data = {
        event: "TabNavigate",
        location: "Dashboard"
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function lumpsumScreen(amount, oneTimeInvestment = false) {
    const data = {
        active: true,
        event: 'navigate',
        location: 'screenGoldSIPInvest',
        data: {
            oneTimeInvestment: oneTimeInvestment,
            ...(amount != null && { amount: String(amount) })
        }
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

// Opens the BBPS bill-payments screen, on a category (e.g. 'Credit Card') when given.
export function payBills(categoryName) {
    console.log('NATIVE EVENT: PAY BILLS', categoryName);
    const data = {
        active: true,
        event: 'navigate',
        location: 'screenBBPS',
        ...(categoryName && { data: { categoryName } })
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

export function vkyc() {
    console.log('NATIVE EVENT: VKYC');
    const data = {
        event: 'navigate',
        location: 'screenVKYCIntro'
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
}

// ---- haptics ----
// haptic(type, pattern?) plays a buzz the best way the surface allows:
//  1. The app, when it has said it handles haptics by injecting
//     `window.__GOSATS_HAPTICS__ = true` (next to __GOSATS_SESSION__): the page
//     posts { event: 'haptic', type, pattern } and the app plays `type` with
//     react-native-haptic-feedback / expo-haptics. Opt-in so a buzz is never
//     played twice — until the app sets the flag it is never asked.
//  2. The Vibration API (Android WebView, Chrome): `pattern` ([on, off, on…] ms).
//  3. iOS (WKWebView / Safari 17.4+), which has no Vibration API: WebKit plays
//     a haptic tick when an <input type="checkbox" switch> is toggled, and a
//     programmatic label click toggles it — one tick per "on" segment of
//     `pattern`, so a heavy or success buzz is two or three quick ticks.
// `type` is the feel, in react-native-haptic-feedback's names — impactLight |
// impactMedium | impactHeavy | selection | notificationSuccess |
// notificationWarning | notificationError.
const HAPTIC_PATTERNS = {
    selection: [8],
    impactLight: [12],
    impactMedium: [24],
    impactHeavy: [30, 40, 30],
    notificationSuccess: [20, 60, 40],
    notificationWarning: [30, 50, 30],
    notificationError: [40, 40, 40, 40, 60]
};

// the hidden switch the iOS ticks toggle, made on first use; null where the
// browser has no switch control (then there is nothing to tick with)
let hapticSwitch = null; // the label · false once the browser proved to have no switch control
function switchHost() {
    if (hapticSwitch) return hapticSwitch;
    if (hapticSwitch === false || typeof document === 'undefined' || !document.body) return null;
    const input = document.createElement('input');
    input.type = 'checkbox';
    if (typeof input.switch !== 'boolean') { hapticSwitch = false; return null; } // no `switch` control here
    input.setAttribute('switch', '');
    input.tabIndex = -1;
    const label = document.createElement('label');
    label.setAttribute('aria-hidden', 'true');
    label.style.cssText = 'position:fixed;left:-9999px;top:0;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none';
    label.appendChild(input);
    document.body.appendChild(label);
    hapticSwitch = label;
    return label;
}

function switchTicks(pattern) {
    const host = switchHost();
    if (!host) return false;
    let at = 0;
    pattern.forEach((ms, i) => {
        if (i % 2 === 0) {
            if (at === 0) host.click();
            else setTimeout(() => host.click(), at);
        }
        at += ms;
    });
    return true;
}

export function haptic(type = 'impactLight', pattern = null) {
    const p = pattern || HAPTIC_PATTERNS[type] || HAPTIC_PATTERNS.impactLight;
    try {
        if (window.__GOSATS_HAPTICS__ && window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({ event: 'haptic', type, pattern: p }));
            return true;
        }
        if (typeof navigator !== 'undefined' && navigator.vibrate) {
            navigator.vibrate(p);
            return true;
        }
        return switchTicks(p);
    } catch (e) {
        // no haptics on this surface
    }
    return false;
}